<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :transferenciasPendientes="transferenciasPendientes"
          :transferenciasPendientesTodos="transferenciasPendientesTodos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Transferencias">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="transferencias" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(saldoAsignar)="data">
              {{ data.item.saldoAsignar | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="asignarTransferencia(data.item)">
                  <i class="fa fa-check"></i>Asignar Transferencia</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" 
              prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import TransferenciaPremiosAsignacion from './TransferenciaPremiosAsignacion.vue';
import Filtro from './TransferenciasPremiosFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferenciasPremios/getField',
  mutationType: 'transferenciasPremios/updateField',
});

export default {
  name: 'TransferenciasPremios',
  components: {
    // appTransferenciaPremiosAsignacion: TransferenciaPremiosAsignacion,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        { key: 'bancoCuenta' },
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha'
        },
        {
          key: 'importe',
          class: 'text-right',
        },
        {
          key: 'saldoAsignar',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
        // {
        //   key: 'selected',
        //   label: '',
        //   class:'text-center'
        // },
      ],

      tableBusy: false,

      // transferenciaPremiosId: 0,
    }
  },
  computed: {
    ...mapFields([
      'transferencias',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'transferenciasPendientes',
      'transferenciasPendientesTodos'
      // 'cantidadSeleccionadas'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.transferenciasPendientes = filtro.transferenciasPendientes;
      this.transferenciasPendientesTodos = filtro.transferenciasPendientesTodos;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('transferenciasPremios/getTransferenciasPremios')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      // this.$router.push({ name: 'ChequeTerceroData', 
      //                     params: { id: item.id }})
    },

    asignarTransferencia(item) {
      this.$router.push({ name: 'TransferenciaPremiosAsignacion', 
                          params: { id: item.id }});
      // this.transferenciaPremiosId = item.id;
      // this.$refs.transferenciaPremiosAsignacionModal.show()
    },
    // closeTransferenciaPremiosAsignacion(transferenciaPremiosActualizada) {
    //   this.$refs.transferenciaPremiosAsignacionModal.hide();
    //   if (transferenciaPremiosActualizada) {
    //     this.getItems();
    //   }
    // }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems(); 
      }
    },    
  }    
}
</script>

<style>
</style>
